//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BlogIndexPage",
  transition: "default",
  async asyncData({ $axios, params, error }) {
    try {
      const qs = require("qs");
      const query = qs.stringify(
        {
          // publicationState: "preview",
          filters: {
            slug: {
              $eq: "wissenswertes",
            },
          },
        },
        {
          encodeValuesOnly: true,
        }
      );
      // console.log("BLOG QUERY: " + query);
      const blogSeiteData = await $axios.$get(
        `${process.env.api_url}/api/pages?${query}&populate=deep&locale=all`
      );
      // console.log("BLOG PARAMS: ", params);
      const breakBlockData = await $axios.$get(
        `${process.env.api_url}/api/boxes-break-blocks?populate=deep&locale=all`
      );
      return { 
        data: {
          blogSeiteData: blogSeiteData.data[0],
          breakBlockData:
            breakBlockData.data.length && breakBlockData.data[0].attributes,
        },
      };
    } catch (err) {
      error({
        statusCode: 404,
        message: "Page not found",
      });
    }
  },
};
